$(document).ready(function () {
  var find =  $("form.blog_search.search__form input").attr("placeholder-text");
//   $("form.blog_search.search__form input").on("input", function(){
//   var find = $(this).val();
//     if( find == "" || find == undefined )
//     {
//     $(".placeholder--tex").hide();
//     }
//     else
//     {
//     $(".placeholder--tex").hide();
//     }

//   })
//   jQuery(document).ready(checkContainer);

// function checkContainer () {
   
//   if($('.boost-pfs-search-suggestion-wrapper').is(':visible')){ //if the container is visible on the page
   
//     $("form.blog_search.search__form input").attr("placeholder", find);
//     console.log(find)
//   } else {
//     setTimeout(checkContainer, 50); //wait 50 ms, then try again
//     console.log("not found")
//   }
// }
//   
//  $(".main-nav__wrapper a.url-deadlink.dropdown_link").hover(
//   function () {
//     $(this).addClass("active_link");
//   },
//   function () {
//     $(this).removeClass("active_link");
//   }
// );
  
//   
//   var menuname =$("#shopify-section-mega-menu-1-new .dropdown_container").attr("data-dropdown");
//  $("#shopify-section-mega-menu-1-new .dropdown_container").parent().addClass('menu_'+menuname);
  
//   var menuname2 =$("#shopify-section-mega-menu-2-new .dropdown_container").attr("data-dropdown");
//  $("#shopify-section-mega-menu-2-new .dropdown_container").parent().addClass('menu_'+menuname2);
  
//   var menuname3 =$("#shopify-section-mega-menu-3-new .dropdown_container").attr("data-dropdown");
//  $("#shopify-section-mega-menu-3-new .dropdown_container").parent().addClass('menu_'+menuname3);

//   
//  $(".menu_shop").hover(
//   function () {
//     $(".menu_shop").addClass("active_link");
//     //$(".menu_shop .dropdown_container.mega-menu").css("dasplay","block!important");
//   },
//   function () {
//     $(".menu_shop").removeClass("active_link");
//     //$(".menu_shop .dropdown_container.mega-menu").css("dasplay","none!important");
//   }
// );
//
//    $(".menu_services").hover(
//   function () {
//     $(".menu_services").addClass("active_link");
//     //$(".menu_shop .dropdown_container.mega-menu").css("dasplay","block!important");
//   },
//   function () {
//     $(".menu_services").removeClass("active_link");
//     //$(".menu_shop .dropdown_container.mega-menu").css("dasplay","none!important");
//   }
// );
  
//   
//    $(".menu_about").hover(
//   function () {
//     $(".menu_about").addClass("active_link");
//     //$(".menu_shop .dropdown_container.mega-menu").css("dasplay","block!important");
//   },
//   function () {
//     $(".menu_about").removeClass("active_link");
//     //$(".menu_shop .dropdown_container.mega-menu").css("dasplay","none!important");
//   }
// );
  
//
//   $("header#header a.mobile_nav.dropdown_link div").click(function(){
//     $(this).toggleClass("open");
//     $(this).parent().parent().parent().find(".dropdown_container").toggle();
//   });
  
//   
  
//   $("footer.footer.new_footer .footer_menu").click(function(){
//     $(this).parent().find("h6").toggleClass("active");
//     $(this).parent().find(".toggle_content").slideToggle();
//   });  
  
  
//
//     $("ul#mobile_menu li a.parent-link--false").click(function(){
//     $(this).toggleClass("active");
//     $(this).parent().find("ul").toggleClass("menu_active");
//   });

  
  
//
//   $(".description.medium-down--hide a.more").click(function(){
//     $(this).parent().toggle();
//      $(this).parent().parent().find(".more-content").show();
//   });
//   $(".description.medium-down--hide a.less").click(function(){
//     $(this).parent().toggle();
//      $(this).parent().parent().find(".less-content").show ();
//   });

//

  
// jQuery(function(){
//   var j = jQuery; //Just a variable for using jQuery without conflicts
//   var addInput = '.quantity'; //This is the id/class of the input you are changing
//  // var n = 1; //n is equal to 1
  
//   //Set default value to n (n = 1)
//  // j(addInput).val(n);

//   //On click add 1 to n
//   j('.purchase-details__quantity.product-quantity-box span.ss-icon.product-plus.js-change-quantity, .qty-wrapper .ss-icon.product-plus.js-change-quantity').on('click', function(){
//    var n = j(this).parent().find(addInput).val();
//     j(this).parent().find(addInput).val(++n);
//   })

//   j('.purchase-details__quantity.product-quantity-box span.ss-icon.product-minus.js-change-quantity, .qty-wrapper .ss-icon.product-minus.js-change-quantity').on('click', function(){
//     //If n is bigger or equal to 1 subtract 1 from n
//    var n = j(this).parent().find(addInput).val();
//       j(this).parent().find(addInput).val(--n);
    
//   });
// });  
  
//   $(".section-wrapper.section_cart span.ss-icon.product-minus, .section-wrapper.section_cart span.ss-icon.product-plus").click(function(){
//     setTimeout(function() {
//     $(this).parent().toggle();
//      $("button.btn.btn--loader.cart_update_btn").trigger( "click" );
//       }, 1000);
//   });
  
 // faq
  $("dl.faqAccordion .q_a_main button").click(function(){
    $(this).toggleClass("active");
    $(this).parent().parent().find("dd#panel-01").slideToggle();
    $(this).parent().find("dd#panel-01").slideToggle();
  }); 

  //
  
// $('.product_gallery_nav.product-gallery__thumbnails.product_gallery_nav--bottom.product-4728568643722-gallery-nav').slick({
//   dots: true,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 3,
//   slidesToScroll: 1,

// });
  
// $('.product_gallery_nav.product-gallery__thumbnails.product_gallery_nav--bottom.product-4728568643722-gallery-nav').slick({
//     arrows: true,
//     rows: 2,
//     slidesPerRow: 3,
//     centerPadding: "0px",
//     dots: false,
//     slidesToShow: 4,
//     touchThreshold: 500,
//     infinite: false
//   });  
  
//////
     /// for mobile
//   if ($(window).width() < 768) {
//       $('html, body').animate({
//         scrollTop: $('.boost-pfs-filter-tree-mobile-button').offset().top-145
//     }, 'slow');
//   }
//   if ($(window).width() >767) {
//     $('html, body').animate({
//         scrollTop: $('div#boost-pfs-filter-tree').offset().top-145
//     }, 'slow');
//   }
  $('.c-block').slick({
    
   infinite: true,
     // speed: 1000,

    autoplay: true,
  autoplaySpeed: 4000,
  slidesToShow: 1,
  slidesToScroll: 1,
     arrows: false,
    cssEase: "linear"
});
     console.log("find");

  var stickyOffset = $('header').offset().top;

$(window).scroll(function(){
  var sticky = $('header'),
      scroll = $(window).scrollTop();

  if (scroll > stickyOffset) sticky.delay(1000).addClass('sticky');
  else sticky.delay(1000).removeClass('sticky');
});

  /////////////////////////Sticky Banner Slider/////////////////////////
  $('.Sticky_banner-slider').slick({
  dots: false,
  arrow: true,
  prevArrow:"<button type='button' class='slick-prev'><svg  viewBox='0 0 100 100'><path d='M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z'></path></svg></button>",
  nextArrow:"<button type='button' class='slick-next'><svg  viewBox='0 0 100 100'><path d='M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z'></path></svg></button>",
  infinite: false,

  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 798,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  /////////////////////Sticky Banner Slider////////////////////////////////////

  
});